{
  "comment": "M4 local layer (spec §10.2-§10.6; plan I1, I4). Tiers: contacts beyond promoteM or while cruising, at most maxRealShips real ships (closest first), demoted beyond demoteM after demoteCalmS out of combat. The main thread syncs every syncS. Player-caused grudges last grudgeS. Traffic pilot: undock at undockSpeed along the bay out axis to traffic-pilot.json undockClearM off the hull (scale SC-5d2), sublight at sublightFraction × maxSpeed, cruise (kinematic contact) once cruiseClearM from any station, drop out of cruise approachDropM from the target, auto-dock from dockStartM off the target station hull (R + dockStartM from its centre, R its bounding radius; SC-5d2), mine mineStandoffM off a rock at minePower, hold at holdOrbitM (off the hull at a station node: R + holdOrbitM; SC-5d2). Threat: an AIPilot is added with a hostile within threatM or on a hit, removed after calmS with none within calmM; aiProfiles per role (M1 ai-profiles.json ids, picked by the agent's seed); traders and miners fly the flee-biased civilian profile (bravery 0.1: flees below 45% hull). Traffic pilot braking: arriveGain (speed per metre, 1/s), arrival at arriveFraction × holdOrbitM, hold-orbit lead orbitLead (rad). Encounters: the strategic danger (0..1) scales the director danger by 1 + dangerGain × danger; each local raider agent cuts the interdiction rate by raiderShare; that thinned rate is then × (1 + dangerRateGain × danger) (TR-6; 0 = off), and a blockade adds its rate after. Starting values, tune freely.",
  "maxRealShips": 40,
  "promoteM": 20000,
  "demoteM": 24000,
  "demoteCalmS": 30,
  "syncS": 5,
  "grudgeS": 120,
  "undockSpeed": 20,
  "undockCorridorM": 5000,
  "sublightFraction": 0.7,
  "cruiseClearM": 5000,
  "approachDropM": 10000,
  "dockStartM": 2000,
  "mineStandoffM": 200,
  "minePower": 0.8,
  "holdOrbitM": 2000,
  "threatM": 3000,
  "calmM": 6000,
  "calmS": 20,
  "arriveGain": 0.5,
  "arriveFraction": 0.5,
  "orbitLead": 0.3,
  "dangerGain": 1,
  "dangerRateGain": 0,
  "raiderShare": 0.25,
  "aiProfiles": {
    "trader": ["civilian"],
    "miner": ["civilian"],
    "supplier": ["rookie"],
    "patrol": ["veteran"],
    "convoy": ["rookie"],
    "raider": ["rookie", "veteran"],
    "constructor": ["rookie"]
  }
}
